export enum SnackbarStatusType {
    success = 'success',
    error = 'error',
    warn = 'warn'
}